export function commercialStockReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_COMMERCIAL_STOCK": 
            return {
                [payload.id]: payload,
                ...state
            };

        case "UPDATE_COMMERCIAL_STOCK": 
            return {
                ...state,
                [payload.id]: payload
            } 
            
        case "GET_COMMERCIAL_STOCKS":        
            return payload;
        
        case "DELETE_COMMERCIAL_STOCK":
            const { [payload]: deleted, ...newState } = state;
            return newState;
        default:
            return state;
    }
    
}